import * as ngCommon from '@angular/common'
import { Component } from '@angular/core'

import * as tabs from '../tabs'

@Component({
  imports: [ngCommon.NgTemplateOutlet],
  selector: 'atn-ds-integrated-vertical-tabs',
  styleUrls: ['./integrated-vertical-tabs.component.scss'],
  templateUrl: './integrated-vertical-tabs.component.html',
})
export class AtnDsIntegratedVerticalTabsComponent extends tabs.Component {}
